import ProfileAccordian from "Components/Cards/ProfileAccordian";
import ContentContainer from "Components/Container/ContentContainer";
import {
  BackButton,
  Description,
  MasterHeader,
  SubDescriptionLight,
  SubTitle,
  Title,
} from "Components/CustomComponents";
import CustomLoader from "Components/CustomComponents/CustomLoader";
import NoDataFound from "Components/CustomComponents/NoDataFound";
import MapFixed from "Components/Map/MapFixed";
import { ActivityLog, RouteWithStopsAndDriver } from "Data/interfaces";
import { useLazyGetDashboardRouteDetailQuery } from "Data/services/dashbaordApi";
import { useLazyGetRouteActivityQuery } from "Data/services/routesApi";
import { getCurrentDate } from "Helper";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import styles from "./index.module.scss";

const RouteTracking: React.FC = () => {
  const [selectedDate] = useState<string>(getCurrentDate());
  const [activityDetails, setActivityDetails] = useState<ActivityLog[] | []>(
    []
  );
  const [routeDetails, setRouteDetails] = useState<RouteWithStopsAndDriver>();
  // console.log(routeDetails);

  const { id } = useParams();
  // console.log(id);

  const [
    getActivityLog,
    { data: activityData, isFetching: activitiesFetching },
  ] = useLazyGetRouteActivityQuery();
  // console.log("activitiesFetching: ", activitiesFetching);
  // console.log("getActivityLog:", activityData);

  const [getDashboardRouteDetails, { data, isFetching }] =
    useLazyGetDashboardRouteDetailQuery();
  // console.log("isFetching:", isFetching);
  // console.log("getDashboardRouteDetails: ", data);


  useEffect(() => {
    getDashboardRouteDetails({ id: id });
    getActivityLog({ id: id, date: selectedDate });
  }, [id]);

  useEffect(() => {
    if (data) {
      setRouteDetails(data.data);
    }
  }, [data]);

  useEffect(() => {
    if (activityData) {
      setActivityDetails(activityData.data);
    }
  }, [activityData]);

  return (
    <div className={styles.RouteTracking}>
      <BackButton isRelative={true} text="Back" classes="mb-1" />
      <ContentContainer classes={`p-3`}>
        {isFetching ? (
          <CustomLoader />
        ) : _.isEmpty(routeDetails) ? (
          <NoDataFound />
        ) : (
          <Container className="mx-0">
            <Row className={styles.contentContainer}>
              <Col lg={7}>
                <div className={styles.mapContainer}>
                  <MapFixed
                    isDirection={true}
                    hasMarker={true}
                    route_id={Number(id)}
                    direction={{
                      origin: {
                        id: Number(routeDetails.route_stops[0].id),
                        lat: parseFloat(routeDetails.route_stops[0].latitude),
                        lng: parseFloat(routeDetails.route_stops[0].longitude),
                        status: routeDetails.route_stops[0].status
                      },
                      destination: {
                        id: Number(routeDetails.route_stops[routeDetails.route_stops.length - 1].id),
                        lat: parseFloat(routeDetails.route_stops[routeDetails.route_stops.length - 1].latitude),
                        lng: parseFloat(routeDetails.route_stops[routeDetails.route_stops.length - 1].longitude),
                        status: routeDetails.route_stops[routeDetails.route_stops.length - 1].status
                      },
                      waypoints: routeDetails.route_stops
                        .slice(1, routeDetails.route_stops.length - 1)
                        ?.map(item => ({ id: item.id, lat: parseFloat(item.latitude), lng: parseFloat(item.longitude), status: item.status })),
                      route_emergency_service: routeDetails?.route_emergency_service || [],
                      route_emergency_stop: routeDetails?.route_emergency_stop || []
                    }}
                    isGestureHandling={true}
                  />
                </div>
              </Col>
              <Col lg={5}>
                <div className={styles.content}>
                  <SubTitle text="Route Tracking" classes="mb-4" />
                  <MasterHeader text={routeDetails?.route_name} />
                  {/* <MasterHeader text={"Route Name"} /> */}
                  <div className="d-flex flex-row gap-2 my-3">
                    <ContentContainer
                      bg="#efefef"
                      hasBoxShadow={false}
                      classes="p-3"
                      style={{ borderRadius: "10px" }}
                    >
                      <Title
                        text={routeDetails?.total_stops as unknown as string}
                        classes="mb-1"
                      />
                      <SubDescriptionLight text="Total Stops" />
                    </ContentContainer>
                    <ContentContainer
                      bg="#efefef"
                      hasBoxShadow={false}
                      classes="p-3"
                      style={{ borderRadius: "10px" }}
                    >
                      <Title
                        text={
                          routeDetails?.remaining_stops as unknown as string
                        }
                        classes="mb-1"
                      />
                      <SubDescriptionLight text="Remaining Stops" />
                    </ContentContainer>
                  </div>
                  <Description text="Current Driver" classes="mb-2" />
                  {activitiesFetching ? (
                    <CustomLoader />
                  ) : _.isEmpty(activityDetails) ? (
                    <NoDataFound />
                  ) : (
                    (activityDetails || []).map((driver) => (
                      <ContentContainer
                        classes="mb-2"
                        bg="#f9f9f9"
                        hasBoxShadow={false}
                        key={driver.id}
                      >
                        <ProfileAccordian
                          totalStops={routeDetails?.total_stops}
                          driver={driver}
                          key={driver.id}
                        />
                      </ContentContainer>
                    ))
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        )}
      </ContentContainer>
    </div>
  );
};

export default RouteTracking;
